export default "__VITE_PUBLIC_ASSET__d635556c__"